import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container} from 'reactstrap';

import ccis from '../../assets/images/contents/ccis.png';
import springer from '../../assets/images/contents/springer_logo.png';

function Publication() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Publication</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">Information</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Publication</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">Publication</H2>
                  <div className="text-dark-200" style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                      <p>
                        <b>Congratulations!</b> Your paper submitted to SCSD2023 is published in Springer CCIS series. Please click on link below to access the papers:<br/>
                        <a href="https://link.springer.com/book/10.1007/978-981-99-0405-1" target="blank">https://link.springer.com/book/10.1007/978-981-99-0405-1</a>                  
                      </p>
                      <Container> 
                        <Row className="justify-content-md-left">  
                          <Col md="auto">
                            <Card>
                              <Card.Img width="50px" height="100px" src={ccis} alt="ccis logo" />                       
                            </Card>                                  
                          </Col>
                        </Row>
                       
                      </Container>
                      <p>
                        The SCDS2015, SCDS2016, SCDS2017, SCDS2018, SCDS2019 and SCDS2021 proceedings were published in the Communications in Computer and Information Science series which is 
                        abstracted (indexed) by DBLP, EI, Scopus and were submitted for the inclusion in ISI Proceedings.
                      </p>
                  </div>
              </div>
          </div>

  </div>
    );
}

export default Publication;